import { addDoc, collection } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { mailTemplates } from './mailTemplates';

/**
 * Send a templated email without any required attachments. Drops a document into
 * the `mail` collection that the email-sending Firebase extension consumes.
 */
export const sendTemplatedEmail = async <T extends keyof typeof mailTemplates>(
  to: string,
  templateName: T,
  params: Parameters<(typeof mailTemplates)[T]>[0],
): Promise<boolean> => {
  try {
    const template = mailTemplates[templateName];
    const { subject, html } = await template(params as any);

    const db = getFirestore(getApp());
    await addDoc(collection(db, 'mail'), {
      to,
      message: {
        subject,
        html,
        text: 'Please view this email in an HTML-compatible email client.',
      },
    });

    return true;
  } catch (error) {
    console.error('Error sending templated email:', error);
    return false;
  }
};
